import { Play } from "@bloomberg/media-ui-iconography";

import { MILLISECONDS_PER_DAY } from "@util/constants";
import {
  getElapsedTimeInMilliseconds,
  getStringifiedElapsedTime,
} from "@util/getElapsedTime";
import { TDateISO } from "types/date";

import * as Eyebrow from "../eyebrow/index";
import * as Image from "../image/index";

import { CardProps } from "./types";

import styles from "./styles.module.css";

export const getTimestamp = (timestamp: TDateISO) => {
  const elapsedTime = getElapsedTimeInMilliseconds(timestamp);

  if (elapsedTime < MILLISECONDS_PER_DAY) {
    const stringifiedElapsedTime = getStringifiedElapsedTime(timestamp);

    return `${stringifiedElapsedTime} ago`;
  }

  const date = new Date(timestamp);

  return `${date.toLocaleString("default", {
    month: "long",
  })} ${date.getDate()}`;
};

export const StyledTimestamp = (props: Pick<CardProps, "timestamp">) => (
  <div className={styles.timestamp}>
    <time>{getTimestamp(props.timestamp)}</time>
  </div>
);

export const StyledText = (
  props: Pick<CardProps, "text" | "url" | "tracker">,
) => (
  <a
    href={props.url}
    className={styles.text}
    data-role="linked-text"
    aria-label={props.text}
    ref={props.tracker?.registerTracking}
  >
    {props.text}
  </a>
);

export const StyledEyebrow = (props: Pick<CardProps, "eyebrow">) => (
  <div className={styles.eyebrow}>
    <Eyebrow.Component {...props.eyebrow} />
  </div>
);

export const StyledPlayIcon = () => (
  <div className={styles.playIcon}>
    <Play aria-label="Play Icon" />
  </div>
);

export const StyledImage = (
  props: Pick<CardProps, "image" | "playIcon" | "url" | "text" | "tracker">,
) => (
  <a
    data-skeleton-selector
    href={props.url}
    tabIndex={-1}
    data-role="linked-image"
    aria-label={`[image]${props.text}`}
    ref={props.tracker?.registerTracking}
  >
    <Image.Component {...props.image} />
    {props.playIcon && <StyledPlayIcon />}
  </a>
);
